module.exports = __webpack_public_path__ + "img/04.aa490bc5.png";